import { Component } from 'react';
import { FormGroup, Input as BootstrapInput, Label } from 'reactstrap';

import './input.css';

class Input extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value || '',
    };
  }

  render() {
    const { label, placeholder, rlabel, type, value, onChange, className } = this.props;
    const formgroupclassname = this.props.formgroupclassname ? this.props.formgroupclassname : 'm-2';
    const fieldId = this.props.id ? this.props.id : this.props.name;

    return (
      <FormGroup className={`${formgroupclassname} ${className}`}>
        {label && (
          <Label className="font-weight-bold mb-0" for={fieldId}>
            {label}
          </Label>
        )}
        <BootstrapInput
          {...this.props}
          value={value}
          onChange={(e) => {
            const value = e.target.value;
            this.setState({ value });
            onChange && onChange(value);
          }}
          type={type}
          name={fieldId}
          id={fieldId}
          placeholder={placeholder}
        />
        {rlabel && (
          <Label className="font-weight-bold mb-0" for={fieldId}>
            {rlabel}
          </Label>
        )}
      </FormGroup>
    );
  }
}

export default Input;
